'use client';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/navigation';
import { EmptyState, Button } from '@minthr-saas/ui-kit';

// 404 — kit EmptyState, centered. Replaces the legacy minthr-* markup so it reads
// correctly in the new ui-kit layout. Reuses the existing (seeded) NotFound.* keys.
const NotFound = () => {
  const { t } = useTranslation();
  const router = useRouter();
  return (
    <div className="tw-flex tw-min-h-screen tw-w-full tw-items-center tw-justify-center tw-p-6">
      <div className="tw-flex tw-flex-col tw-items-center">
        <EmptyState
          type="no-results"
          illustration={
            <img
              src="/images/notfound.svg"
              alt=""
              className="tw-mx-auto tw-mb-2 tw-w-full tw-max-w-[220px]"
            />
          }
          title={t('NotFound.Title')}
          description={t('NotFound.Message')}
          primaryAction={
            <Button variant="primary" onClick={() => router.push('/')}>
              {t('ReturnToDash')}
            </Button>
          }
        />
        <p className="tw-mt-4 tw-text-center tw-text-[13px] tw-text-gray-500">
          {t('Contact.Support')}{' '}
          <a
            href="mailto:support@minthr.com"
            className="tw-font-medium tw-text-gray-700 tw-underline hover:tw-text-gray-900"
          >
            support@minthr.com
          </a>
        </p>
      </div>
    </div>
  );
};

export default NotFound;
